<div class="row mb-3 mt-2">
    <div class="col-4" style="text-align: left">
        <label for="name" class="form-label">Field :</label>
        <select class="form-select border border-dark" [(ngModel)]="field1" name="field1" id="field1"
            (change)="onOptionSelectedfield_1($event)">
            <option [selected]="true" disabled [value]="0">Select Field</option>
            <option *ngFor="let stages of fieldDDl" [value]="stages.value">
                {{ stages.label }}
            </option>
        </select>
    </div>
    <div class="col-2">
        <label for="name" class="form-label"># of Project :</label>
        <select class="form-select border border-dark" [(ngModel)]="projectNo" name="projectNo" id="projectNo"
            (change)="onProjectChange($event)">
            <option [selected]="true" disabled [value]="0">Select One</option>
            <option *ngFor="let project of projectNoList" [value]="project.Id">
                {{ project.Name }}
            </option>
        </select>

    </div>
</div>

<div class="row" *ngIf="selectedConfigDataList.length > 0">
    <div class="col-2">
        <div style="height: auto;display: block;border: 1px solid lightgray;padding: 11px;margin: 6px;">
            <h4 style="text-align: center;">Project 1</h4>
            <div class="field">
                <label for="name" class="form-label">Plant:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[0].plantId"
                    name="plantId1" id="plantId1" (change)="getSelectedId($event, selectedConfigDataList[0], 1)">
                    <option [value]="0">Select Plant</option>
                    <option *ngFor="let plant of plants" [value]="plant.Id">
                        {{ plant.Name }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Train:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[0].trainId"
                    name="trainId1" id="trainId1" (change)="onTrainChange($event, selectedConfigDataList[0],1)">
                    <option [value]="0">Select Train</option>
                    <option *ngFor="let train of selectedConfigDataList[0].trainList" [value]="train.value">
                        {{ train.label }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Stages:</label>
                <select class="form-select border border-dark" name="stage1" *ngIf="!UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[0],1)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id" [selected]="stages.Id === 1">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage1" *ngIf="project1trainStage == 1 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[0],1)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id" [selected]="stages.Id === 1">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage1" *ngIf="project1trainStage == 2 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[0],1)">
                    <option *ngFor="let stages of stage2" [value]="stages.Id" [selected]="stages.Id === 1">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage1" *ngIf="project1trainStage == 3 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[0],1)">
                    <option *ngFor="let stages of stage3" [value]="stages.Id" [selected]="stages.Id === 1">
                        {{ stages.Name }}
                    </option>
                </select>
            </div>
           
            <!-- <div class="field mt-2">
                <input class='radio' name="statusGroup" type='radio' id="Project1" value="Project1"
                    [(ngModel)]='selectedConfigDataList[0].showSystemConfig' (change)="resetOtherConfig(1)" />
                <label>Display System Configuration</label>
            </div> -->
        </div>

    </div>
    <div class="col-2">
        <div style="height: auto;display: block;border: 1px solid lightgray;padding: 11px;margin: 6px;">
            <h4 style="text-align: center;">Project 2</h4>
            <div class="field">
                <label for="name" class="form-label">Plant:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[1].plantId"
                    name="plantId2" id="plantId2" (change)="getSelectedId($event, selectedConfigDataList[1], 2)">
                    <option [value]="0">Select Plant</option>
                    <option *ngFor="let plant of plants" [value]="plant.Id">
                        {{ plant.Name }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Train:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[1].trainId"
                    name="trainId2" id="trainId2" (change)="onTrainChange($event, selectedConfigDataList[1],2)">
                    <option [value]="0">Select Train</option>
                    <option *ngFor="let train of selectedConfigDataList[1].trainList" [value]="train.value">
                        {{ train.label }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Stages:</label>
                <select class="form-select border border-dark" name="stage2" *ngIf="!UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[1],2)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage2" *ngIf="project2trainStage == 1 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[1],2)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage2" *ngIf="project2trainStage == 2 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[1],2)">
                    <option *ngFor="let stages of stage2" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage2" *ngIf="project2trainStage == 3 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[1],2)">
                    <option *ngFor="let stages of stage3" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>
                
            </div>
            <!-- <div class="field mt-2">
                <input class='radio' name="statusGroup" type='radio' id="Project2" value="Project2"
                    [(ngModel)]='selectedConfigDataList[1].showSystemConfig' (change)="resetOtherConfig(2)" />
                <label>Display System Configuration</label>
            </div> -->
        </div>
    </div>

    <div class="col-2" *ngIf="selectedConfigDataList[2]">
        <div style="height: auto;display: block;border: 1px solid lightgray;padding: 11px;margin: 6px;">
            <h4 style="text-align: center;">Project 3</h4>
            <div class="field">
                <label for="name" class="form-label">Plant:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[2].plantId"
                    name="plantId3" id="plantId3" (change)="getSelectedId($event, selectedConfigDataList[2], 3)">
                    <option [value]="0">Select Plant</option>
                    <option *ngFor="let plant of plants" [value]="plant.Id">
                        {{ plant.Name }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Train:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[2].trainId"
                    name="trainId3" id="trainId3" (change)="onTrainChange($event, selectedConfigDataList[2],3)">
                    <option [value]="0">Select Train</option>
                    <option *ngFor="let train of selectedConfigDataList[2].trainList" [value]="train.value">
                        {{ train.label }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Stages:</label>
                <select class="form-select border border-dark" name="stage3" *ngIf="!UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[2],3)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage3" *ngIf="project3trainStage == 1 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[2],3)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage3" *ngIf="project3trainStage == 2 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[2],3)">
                    <option *ngFor="let stages of stage2" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage3" *ngIf="project3trainStage == 3 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[2],3)">
                    <option *ngFor="let stages of stage3" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>
               
            </div>
            <!-- <div class="field mt-2">
                <input class='radio' name="statusGroup" type='radio' id="Project3" value="Project3"
                    [(ngModel)]='selectedConfigDataList[2].showSystemConfig' (change)="resetOtherConfig(3)" />
                <label>Display System Configuration</label>
            </div> -->
        </div>
    </div>
    <div class="col-2" *ngIf="selectedConfigDataList[3]">
        <div style="height: auto;display: block;border: 1px solid lightgray;padding: 11px;margin: 6px;">
            <h4 style="text-align: center;">Project 4</h4>
            <div class="field">
                <label for="name" class="form-label">Plant:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[3].plantId"
                    name="plantId4" id="plantId4" (change)="getSelectedId($event, selectedConfigDataList[3], 4)">
                    <option [value]="0">Select Plant</option>
                    <option *ngFor="let plant of plants" [value]="plant.Id">
                        {{ plant.Name }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Train:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[3].trainId"
                    name="trainId4" id="trainId4" (change)="onTrainChange($event, selectedConfigDataList[3],4)">
                    <option [value]="0">Select Train</option>
                    <option *ngFor="let train of selectedConfigDataList[3].trainList" [value]="train.value">
                        {{ train.label }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Stages:</label>
                <select class="form-select border border-dark" name="stage4" *ngIf="!UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[3],4)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage4" *ngIf="project4trainStage == 1 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[3],4)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage4" *ngIf="project4trainStage == 2 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[3],4)">
                    <option *ngFor="let stages of stage2" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage4" *ngIf="project4trainStage == 3 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[3],4)">
                    <option *ngFor="let stages of stage3" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>
               
            </div>
            <!-- <div class="field mt-2">
                <input class='radio' name="statusGroup" type='radio' id="Project4" value="Project4"
                    [(ngModel)]='selectedConfigDataList[3].showSystemConfig' (change)="resetOtherConfig(4)" />
                <label>Display System Configuration</label>
            </div> -->
        </div>
    </div>
    <div class="col-2" *ngIf="selectedConfigDataList[4]">
        <div style="height: auto;display: block;border: 1px solid lightgray;padding: 11px;margin: 6px;">
            <h4 style="text-align: center;">Project 5</h4>
            <div class="field">
                <label for="name" class="form-label">Plant:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[4].plantId"
                    name="plantId5" id="plantId5" (change)="getSelectedId($event, selectedConfigDataList[4], 5)">
                    <option [value]="0">Select Plant</option>
                    <option *ngFor="let plant of plants" [value]="plant.Id">
                        {{ plant.Name }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Train:</label>
                <select class="form-select border border-dark" [(ngModel)]="selectedConfigDataList[4].trainId"
                    name="trainId5" id="trainId5" (change)="onTrainChange($event, selectedConfigDataList[4],5)">
                    <option [value]="0">Select Train</option>
                    <option *ngFor="let train of selectedConfigDataList[4].trainList" [value]="train.value">
                        {{ train.label }}
                    </option>
                </select>
            </div>
            <div class="field mt-1">
                <label for="name" class="form-label">Stages:</label>
                <select class="form-select border border-dark" name="stage5" *ngIf="!UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[4],5)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage5" *ngIf="project5trainStage == 1 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[4],5)">
                    <option *ngFor="let stages of stageTotal" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage5" *ngIf="project5trainStage == 2 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[4],5)">
                    <option *ngFor="let stages of stage2" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>

                <select class="form-select border border-dark" name="stage5" *ngIf="project5trainStage == 3 && UDSelected"
                    (change)="onStageChange($event, selectedConfigDataList[4],5)">
                    <option *ngFor="let stages of stage3" [value]="stages.Id">
                        {{ stages.Name }}
                    </option>
                </select>
                
            </div>
            <!-- <div class="field mt-2">
                <input class='radio' name="statusGroup" type='radio' id="Project5" value="Project5"
                    [(ngModel)]='selectedConfigDataList[4].showSystemConfig' (change)="resetOtherConfig(5)" />
                <label>Display System Configuration</label>
            </div> -->
        </div>
    </div>
</div>



<div class="row  mb-3 mt-2">
    <div class="col-5">
        <button type="button" class="btn" (click)="showGraph()">
            Generate Comparison Graph
        </button>
        <button [hidden]="!downloadbtn" style="margin-left: 20px;" type="button" class="btn" 
        (click)="captureScreen()">Download</button>
    </div>

    

</div>

<div #captureArea>
    <div style="padding: 10px;">
        <div class="row mb-3 mt-2">
            <div class="col-6">
                <label>Title</label>
                <div style="padding: 7px;border: 1px solid black;height: 138px;">
                    {{title}}
                </div>
            </div>
            <div class="col-6">
                <label>Legends</label>
                <div style="padding: 7px;border: 1px solid black;height: 138px;">
                    <div *ngIf="projectNo=='2'">
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: blue;"></i>
                          
                            {{project1PlantName}}/{{project1TrainName}}/{{'Stage'+' '+project1Stage}}</p>
                            
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: red;"></i>
                            {{project2PlantName}}/{{project2TrainName}}/{{'Stage'+' '+project2Stage}}</p>
                    </div>
                    <div *ngIf="projectNo=='3'">
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: blue;"></i>
                            {{project1PlantName}}/{{project1TrainName}}/{{'Stage'+' '+project1Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: red;"></i>
                            {{project2PlantName}}/{{project2TrainName}}/{{'Stage'+' '+project2Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: green;"></i>
                            {{project3PlantName}}/{{project3TrainName}}/{{'Stage'+' '+project3Stage}}</p>
                    </div>
                    <div *ngIf="projectNo=='4'">
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: blue;"></i>
                            {{project1PlantName}}/{{project1TrainName}}/{{'Stage'+' '+project1Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: red;"></i>
                            {{project2PlantName}}/{{project2TrainName}}/{{'Stage'+' '+project2Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: green;"></i>
                            {{project3PlantName}}/{{project3TrainName}}/{{'Stage'+' '+project3Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: pink;"></i>
                            {{project4PlantName}}/{{project4TrainName}}/{{'Stage'+' '+project4Stage}}</p>
                    </div>
                    <div *ngIf="projectNo=='5'">
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: blue;"></i>
                            {{project1PlantName}}/{{project1TrainName}}/{{'Stage'+' '+project1Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: red;"></i>
                            {{project2PlantName}}/{{project2TrainName}}/{{'Stage'+' '+project2Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: green;"></i>
                            {{project3PlantName}}/{{project3TrainName}}/{{'Stage'+' '+project3Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: pink;"></i>
                            {{project4PlantName}}/{{project4TrainName}}/{{'Stage'+' '+project4Stage}}</p>
                        <p style="padding: 0px;margin: 0px;"><i class="bi bi-circle-fill"
                                style="font-size: 10px; color: yellow;"></i>
                            {{project5PlantName}}/{{project5TrainName}}/{{'Stage'+' '+project5Stage}}</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="row" style="text-align: center;">

            <div id="plot" style="border:deepskyblue;" style="height: 700px;width:NewWidth">
            </div>
        </div>
    </div>
</div>